if (!customElements.get('blur-up')) {
  customElements.define(
    'blur-up',
    class BlurUp extends HTMLElement {
      connectedCallback() {
        const img = this.querySelector('img');
        if (!img || !this.classList.contains('blur-up--pending')) return;

        const reveal = (loaded) => {
          this.classList.remove('blur-up--pending');
          // The placeholder is set inline, so only JS can drop it. Keep it when
          // the photo failed - an empty slide is worse than a blurry one.
          if (loaded) this.style.backgroundImage = 'none';
        };

        img.addEventListener('load', () => reveal(true), { once: true });
        img.addEventListener('error', () => reveal(false), { once: true });

        if (img.complete) reveal(img.naturalWidth > 0);
      }
    }
  );
}
